<template>
  <div class="the-navbar__user-meta flex items-center" v-if="$store.state.AppActiveCompany.name">

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUserInfo.name }}</p>
      <small style="position: absolute; bottom: 15px; right: 82px">{{ role }}</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
          <img key="onlineImg" :src="activeUserInfo.photoURL" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 14rem">

          <!--<li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="SettingsIcon" svgClasses="w-4 h-4" />
            <router-link tag="div" to="/companySettings" >
              <span class="ml-2">Minha Empres a</span>
            </router-link>
          </li>-->

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <a-icon type="rollback" />

            <router-link tag="div" to="/companySelect/1" >
              <span class="ml-2">Mudar Empresa</span>
            </router-link>
          </li>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />

            <router-link tag="div" to="/accountSettings/0" >
              <span class="ml-2">Minha Conta</span>
            </router-link>
          </li>

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Sair</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import roles from '@/components/role/roles.js'

export default {
  
  created () {

  },

  data() {
    return {
      role : 'Desconhecido'
    }
  },
  computed: {
    activeUserInfo() {
      let activeUserInfo = this.$store.getters.getUserStoredData
      this.role = roles.getRoleName(activeUserInfo.role)


      // this.$store.dispatch('updateUserPhoto', !activeUserInfo.photoURL ? require("@/assets/images/portrait/small/no-photo.jpg") : activeUserInfo.photoURL)

      return activeUserInfo
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('logout')
    },
  }
}
</script>
